import type { StyleRule } from '@archipro-design/aria';
import { captionClassName, pxToRem } from '@archipro-design/aria';

export const MetricStatsWrapper: StyleRule = ({ theme }) => ({
    width: pxToRem(434),
    paddingTop: pxToRem(3),
    marginLeft: pxToRem(2),
    marginBottom: theme.siteVariables.spaces['space-240'],
});

export const MetricStatsContainer: StyleRule = ({ theme }) => {
    const commonLabelStyles = {
        fontSize: pxToRem(22),
        fontWeight: '400',
        letterSpacing: theme.siteVariables.letterSpacingMedium,
        lineHeight: theme.siteVariables.lineHeightSmallest,
        color: theme.siteVariables.colors.charcoal[250],
        textTransform: 'uppercase',
    };

    return {
        display: 'block',
        '&:first-child': {
            borderTop: 'none',
        },
        '& > [role=listitem]': {
            '& > *': {
                marginLeft: pxToRem(-2),
            },
            paddingTop: pxToRem(20),
            height: pxToRem(148),
            display: 'block',
            marginBottom: 0,
            borderColor: theme.siteVariables.colors.primitive.black,
            '&:first-child ': {
                [`& .${captionClassName}`]: {
                    width: pxToRem(98),
                    ...commonLabelStyles,
                },
            },
        },
    };
};

export const MetricText: StyleRule = ({ theme }) => ({
    position: 'relative',
    top: pxToRem(1.5),
    margin: 0,
    paddingRight: 0,
    color: theme.siteVariables.colorScheme.default?.foreground2,

    '& a': {
        color: 'inherit',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
});

export const UsuallyRespondsWithin: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(30),
    paddingBottom: pxToRem(20),
    fontSize: pxToRem(22),
    fontWeight: '400',
    letterSpacing: theme.siteVariables.letterSpacingMedium,
    lineHeight: theme.siteVariables.lineHeightSmallest,
    color: theme.siteVariables.colors.charcoal[250],
    textTransform: 'uppercase',
});
